/**
 * Custom Gym Banner — Text + Color block (cgb_custom_text) ATC validator.
 *
 * Both V1 (gym-shorts-v3-addon.js) and V2 (custom-gym-banner-addon-pair.js)
 * intercept [data-to-cart] click in capture phase and call publishEvent('cart:add')
 * directly, bypassing native form HTML5 validation. This means the `required`
 * attribute on cgb-text inputs is silently ignored and orders ship with empty
 * "Your Text 1" / "Your Text 2" line-item properties.
 *
 * This script registers a capture-phase click listener on document. Because
 * snippets/custom-gym-banner-text-color.liquid is rendered EARLIER in
 * block_order than the addon snippets, its <script type="module"> loads first
 * → this listener registers before V1/V2's listeners → it runs first → it can
 * preventDefault + stopImmediatePropagation, blocking V1/V2 from running
 * (and the native form submit too).
 *
 * If valid (all required cgb fields filled): falls through to V1/V2/native.
 */
(() => {
  if (window.__cgbTextValidatorInstalled) return;
  window.__cgbTextValidatorInstalled = true;

  const SELECTOR_FIELD = '.cgb-field';
  const SELECTOR_INPUT = '.cgb-field input[required]';
  const SELECTOR_BTN = '[data-to-cart]';
  const CLASS_ERROR = 'cgb-field--error';

  const setError = (input, message) => {
    const field = input.closest(SELECTOR_FIELD);
    if (!field) return;
    field.classList.add(CLASS_ERROR);
    const errorEl = field.querySelector('.cgb-field__error');
    if (errorEl) errorEl.textContent = message || input.dataset.errorMessage || 'Please fill in this field.';
  };

  const clearError = (input) => {
    const field = input.closest(SELECTOR_FIELD);
    if (!field) return;
    field.classList.remove(CLASS_ERROR);
    const errorEl = field.querySelector('.cgb-field__error');
    if (errorEl) errorEl.textContent = '';
  };

  // Validate on ATC click — capture phase, runs before V1/V2 intercepts
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(SELECTOR_BTN);
    if (!btn) return;

    const inputs = document.querySelectorAll(SELECTOR_INPUT);
    if (inputs.length === 0) return;

    let firstInvalid = null;
    inputs.forEach(input => {
      if (!input.value || !input.value.trim()) {
        setError(input);
        if (!firstInvalid) firstInvalid = input;
      } else {
        clearError(input);
      }
    });

    if (firstInvalid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      try {
        firstInvalid.focus({ preventScroll: false });
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (_) { /* noop */ }
    }
  }, true);

  // Live-clear error as user types
  document.addEventListener('input', (e) => {
    if (!e.target.matches || !e.target.matches(SELECTOR_INPUT)) return;
    if (e.target.value && e.target.value.trim()) clearError(e.target);
  });
})();
